/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_No_Shared_ActionInputs */

const en_samples_no_shared_action = /** @type {(inputs: Samples_No_Shared_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No shared action for mixed statuses`)
};

const es_samples_no_shared_action = /** @type {(inputs: Samples_No_Shared_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin accion comun para estados mixtos`)
};

/**
* | output |
* | --- |
* | "No shared action for mixed statuses" |
*
* @param {Samples_No_Shared_ActionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_no_shared_action = /** @type {((inputs?: Samples_No_Shared_ActionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_No_Shared_ActionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_no_shared_action(inputs)
	return es_samples_no_shared_action(inputs)
});